import type { PharosApiResponse } from '@klareospace/pharos-lib-types';
import type { ApiClient } from '../api/api-client';

export function createFeatureFlagsApi(client: ApiClient): {
  fetchActiveFlags: () => Promise<string[]>;
} {
  return {
    fetchActiveFlags: async (): Promise<string[]> => {
      const response = await client.execute<PharosApiResponse<string[]>>(() => client.instance.get('/feature-flags'));
      return response.data ?? [];
    },
  };
}
